export default __webpack_public_path__ + "static/media/thum4.2fa31c53.jpg";